export const defaultSizeLimit = 2;
export const supportedImageTypes = ".png, .jpg, .jpeg";
export const expertiseNumber = 5;
export const googleMeetingLink = "https://drive.google.com/file/d/1OpERGv7ATyEwlMXxYguqNmDmj8H3MGqF/view";